export default '2.96.0';